import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const liveTapListSyncDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.tapList,
  componentType: LAYOUT_COMPONENT_TYPE.liveTapListSync,
  registryBlockKey: REGISTRY_BLOCK.presentation.liveTapListSync,
  displayOrder: 5,
  content: {
    sectionTitle: loc3('Vom Fass', 'On tap', 'Đang rót'),
    supporting: loc3(
      'Aktuelle Zapfhähne — wechseln wöchentlich.',
      'Current taps — rotate weekly.',
      'Vòi hiện tại — đổi hàng tuần.',
    ),
    taps: loc3(
      'Helles — 4,50 € / 0,3l\nIPA Craft — 5,80 € / 0,3l\nPils — 4,20 € / 0,3l',
      'Helles — 4,50 € / 0.3l\nCraft IPA — 5,80 € / 0.3l\nPils — 4,20 € / 0.3l',
      'Helles — 4,50 € / 0,3l\nIPA craft — 5,80 € / 0,3l\nPils — 4,20 € / 0,3l',
    ),
  },
  media: {},
};
